export enum PaymentFI {
  SameAsBooker = "sameAsBooker",
  HolderFirstName = "holderFirstName",
  HolderLastName = "holderLastName",
  CardNumber = "cardNumber",
  ExpiryDate = "expiryDate",
}
